import api from '@/core/api/client';

export type Ph24LogDomain =
  | 'unidade_medida'
  | 'forma_farmaceutica'
  | 'produto'
  | 'sinonimo'
  | 'posologia'
  | 'capsula'
  | 'produto_incompativel'
  | 'conselho_regional'
  | 'orcamento';

export type Ph24LogOrigin = 'captura' | 'envio';

export interface Ph24Log {
  id: string;
  domain: Ph24LogDomain;
  origin: Ph24LogOrigin;
  entityId: string;
  reason: string;
  httpStatus: number | null;
  createdAt: string;
}

export interface Ph24LogsFilters {
  companyId: string;
  from?: string;
  to?: string;
  domain?: Ph24LogDomain;
  origin?: Ph24LogOrigin;
  search?: string;
}

export interface Ph24LogsPage {
  items: Ph24Log[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

function toParams(filters: Ph24LogsFilters): Record<string, string> {
  return Object.fromEntries(Object.entries(filters).filter(([, value]) => value)) as Record<string, string>;
}

export const ph24LogsService = {
  async list(filters: Ph24LogsFilters & { page: number; pageSize: number }): Promise<Ph24LogsPage> {
    const res = await api.get<{ success: boolean } & Ph24LogsPage>('/ph24-logs', {
      params: { ...toParams(filters), page: filters.page, pageSize: filters.pageSize },
    });
    const { items, total, page, pageSize, totalPages } = res.data;
    return { items, total, page, pageSize, totalPages };
  },

  async purge(filters: Ph24LogsFilters): Promise<number> {
    const res = await api.delete<{ success: boolean; deleted: number }>('/ph24-logs', { params: toParams(filters) });
    return res.data.deleted;
  },
};
